import { tokens } from '@opendoor/tokens-studio/dist/bricks-next/tokens/Components';

import { isKeyOfObject } from '../../../../helpers/utils';
import { Box } from '../../../Box';
import { useCheckInputLabel } from '../../../shared/InputLabelContext';
import { Text } from '../../../Text';
import { CheckboxRadioStateProps, SharedCheckboxRadioGroupProps } from './types';

const { radioCheckbox } = tokens;

/**
 * Title/Support text for checkbox and radio group
 */
export const CheckboxRadioGroupLabel = ({
  size,
  title,
  supportText,
  id,
  state,
  required,
}: Pick<SharedCheckboxRadioGroupProps, 'size' | 'title' | 'supportText' | 'id'> &
  CheckboxRadioStateProps & {
    /**
     * Shows the astrick if the checkbox or radio is required
     */
    required?: boolean;
  }) => {
  useCheckInputLabel(title);

  if (!title) {
    return null;
  }

  return (
    <Box>
      <Text
        tag="label"
        id={id}
        typography={radioCheckbox.typography.title[size]}
        color={
          isKeyOfObject(state, radioCheckbox.color.content.title.state)
            ? radioCheckbox.color.content.title.state[state]
            : radioCheckbox.color.content.title.default
        }
      >
        {title}
        {required ? ' *' : ''}
      </Text>

      {!!supportText && (
        <Text
          tag="span"
          typography={radioCheckbox.typography.supportText.default}
          color={
            isKeyOfObject(state, radioCheckbox.color.content.supportText.state)
              ? radioCheckbox.color.content.supportText.state[state]
              : radioCheckbox.color.content.supportText.default
          }
        >
          {supportText}
        </Text>
      )}
    </Box>
  );
};
